/**
 *
 * @param node
 * @returns {Job}
 */
Job.create = function (node) {
    var job = new Job();

    job.__node = node;
    job.label = Utils.getNextDefaultLabel(node.jobs, "Job", 1);
    job.id = Utils.getNextDefaultId(node.jobs, "job", 1);
    job.startTimestamp = moment().format();
    job.fromNextFullOf = "m";
    job.action = {
        type: "nodeService",
        content: {}
    };

    return job;
};

/**
 *
 * @param node
 * @param job
 * @returns {*}
 */
Job.bind = function (node, job) {
    Utils.inheritMethods(job, new Job());

    job.bind(node);

    return job;
};

/**
 *
 */
function Job() {
    /**
     *
     */
    Job.prototype.bind = function (node) {
        this.class = "Job";
        this.__node = node;
    };

    /**
     *
     */
    Job.prototype.maximumTimestamp = function () {
        return this.content.timeline.length ? this.content.timeline[this.content.timeline.length - 1].timestamp : null;
    };
}
